import { HttpParams } from '@angular/common/http';
import {Pageable} from "../../../../utils/pageable";

export const createPageableParams = (pageable?: Pageable): HttpParams => {
  if (!pageable) {
    return new HttpParams();
  }
  return pageable.appendParams(new HttpParams());
};

export const appendIfDefined = (
  params: HttpParams,
  key: string,
  value?: string | number | boolean | null,
): HttpParams => {
  if (value === undefined || value === null) {
    return params;
  }
  // A blank string is the "no filter" sentinel on the frontend side (e.g. the ALL course
  // filter, whose FilterDefinition.filter is an empty string). The API contract expects such
  // a filter to be absent from the query - sending it as an empty value makes the backend
  // treat it as a real code and fail the lookup.
  if (typeof value === 'string' && value.trim().length === 0) {
    return params;
  }
  return params.append(key, String(value));
};

export const appendCollection = (
  params: HttpParams,
  key: string,
  values?: Array<string | number | boolean> | null,
): HttpParams => {
  if (!values || values.length === 0) {
    return params;
  }
  return values.reduce((acc, value) => {
    if (value === undefined || value === null) {
      return acc;
    }
    return acc.append(key, String(value));
  }, params);
};

export const serializeDateInput = (
  value?: string | Date | null,
): string | null => {
  if (value === undefined || value === null) {
    return null;
  }
  return value instanceof Date ? value.toISOString() : value;
};
